import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { toast } from 'react-toastify';
import ColorPicker from 'src/components/Colorpicker/index-beta';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

/**
 * SimpleBubbleChart de correlação.
 *
 * Segue o mesmo contrato dos demais gráficos integrados ao ChartManager:
 *   - `this.manager` orquestra ciclo de cores, highlit e color picker
 *   - `this.colorPickerRef` aponta para o componente do color picker
 *   - `this.configurationError` carrega o erro vindo do ThemeManager
 *
 * Como cada bolha mapeia para uma pergunta correlacionada (via `meta.resposta.pergunta`),
 * a interação de mudança de cor é por duplo clique no item — abrindo o color picker
 * via `ColorPickerManager`. Não há clique simples especial neste gráfico.
 */
class SimpleBubbleChart extends React.Component {
  constructor(props) {
    super(props);
    const { error } = this.props;
    this.configurationError = error;
    this.colorPickerRef = React.createRef();
    this.manager = useChartManagement(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.manager.changesChecker(nextProps);
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possível abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    if (!this.configurationError) return;
    toast.error(this.configurationError.toString());
  }

  onChartReady(echarts) {
    this.echarts = echarts;
  }

  render() {
    const { colorPickerColors, chartRef } = this.props;
    const options = this.manager.getOptions();

    if (!options || !options.series) {
      return null;
    }

    return (
      <>
        <ReactEcharts
          option={options}
          onChartReady={(echarts) => this.onChartReady(echarts)}
          ref={(echartsRef) => {
            if (chartRef) chartRef.current = echartsRef;
            this.chartRef = echartsRef;
          }}
          onEvents={{
            dblclick: (ctx) => this.manager.handleOnDoubleClick(ctx),
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
      </>
    );
  }
}

export default SimpleBubbleChart;
